import {useMemo} from 'react'

export interface ChronicleCommand {
  key: string
  description: string
}

const CHRONICLE_COMMANDS: ChronicleCommand[] = [
  {key: '/chronicle standup', description: 'Get a report on your work from the last day'},
  {key: '/chronicle search', description: 'Search all session content by keyword or topic'},
  {key: '/chronicle tips', description: 'Get personalized tips based on usage patterns'},
  {key: '/chronicle cost-tips', description: 'Get personalized tips to reduce token usage and cost'},
  {key: '/chronicle improve', description: 'Suggest improvements to copilot-instructions.md'},
]

/**
 * Returns chronicle commands that match the current input text as a prefix.
 */
export function useChronicleAutocomplete(currentText: string) {
  const suggestions = useMemo(() => {
    const trimmed = currentText.trimStart()
    if (!trimmed || trimmed.length < 1) return []

    return CHRONICLE_COMMANDS.filter(cmd => cmd.key.startsWith(trimmed) && cmd.key !== trimmed)
  }, [currentText])

  return suggestions
}
